import { render } from "./probaworkflows_layout.html?vue&type=template&id=c31e665e&external"
import script from "./probaworkflows_layout.js?vue&type=script&lang=js&external"
export * from "./probaworkflows_layout.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__